<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <media-details-page />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import MediaDetailsPage from "./components/MediaDetailsPage";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    MediaDetailsPage,
    // ProjectsTable,
  },
};
</script>
